var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBox),expression:"showBox"}],class:['levitated-container', _vm.displayModeClassName]},[_c('div',{class:[
      'box',
      { display: _vm.showBox ? 'block' : 'none', red_point: _vm.showRedPoint },
      _vm.showBoxAnimation ? ['animate__animated', 'animate__bounceIn'] : '',
    ],on:{"click":_vm.handleClickBox}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(require(`@/assets/images/detail/box-gift.png`)),expression:"require(`@/assets/images/detail/box-gift.png`)"}],class:[
        'animate__animated',
        'animate__wobble',
        _vm.wobbleSignal ? 'active' : '',
      ],attrs:{"alt":"gift-icon"}}),_vm._v(" "),_c('p',{staticClass:"activity_desc",style:({ display: `${_vm.showActivityDesc ? 'block' : 'none'}` })},[_vm._v("\n      活动福利\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }